/**
 * Phase-1 access control for the Agents (Agent Studio) feature.
 *
 * The set of accounts allowed to see and use Agents during the gated rollout
 * is provided through the `VUE_APP_AGENTS_ALLOWED_ACCOUNTS` environment
 * variable, as a comma-separated list of account IDs. A single `*` entry
 * allows every account (useful for staging / local development).
 *
 * When the variable is empty or unset, no account has access.
 */
const allowedAccounts = (process.env.VUE_APP_AGENTS_ALLOWED_ACCOUNTS || '')
  .split(',')
  .map(id => id.trim())
  .filter(Boolean)

/**
 * Return whether the given account is allowed to access the Agents feature.
 * @param {string} accountId current account id (e.g. state.auth.account.id)
 * @returns {boolean} true if the account can see/use Agents, false otherwise
 */
export function hasAgentsAccess (accountId) {
  if (!accountId) {
    return false
  }
  if (allowedAccounts.includes('*')) {
    return true
  }
  return allowedAccounts.includes(accountId)
}

export { allowedAccounts }
